import { NgModule } from '@angular/core';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { KYMW4502Component } from './kymw4502.component';
import { GetMediumListForFeatureCopyService } from './api-services/getMediumListForFeatureCopy.service';
import { ExecuteFeatureCopyService } from './api-services/executeFeatureCopy.service';
import { PlessSharedModule } from 'src/app/shared/pless-shared.module';

/**
 * 撮影費請求リスト出力画面 モジュール設定クラス
 * @export KYMW4502Module
 * @class KYMW4502Module
 */
@NgModule({
  imports: [
    AppCommonsModule,
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
  ],
  declarations: [
    KYMW4502Component,
  ],
  providers: [
    GetMediumListForFeatureCopyService,
    ExecuteFeatureCopyService,
  ],
})

export class KYMW4502Module { }
